import React, { useCallback, useState } from "react";

import styles from "./style.module.scss";

interface DragAndDropProps {
  className?: string;
  children?: React.ReactNode;
  onDragOver?: (isOver: boolean) => void;
  onDrop?: (files: File[]) => void;
  onDragEnter?: () => void;
}

interface DragAndDropViewState {
  isOver: boolean;
}

const DragAndDrop: React.FC<DragAndDropProps> = (props: DragAndDropProps) => {
  const [state, setState] = useState<DragAndDropViewState>({
    isOver: false,
  });
  const onDragEnter = useCallback(
    (ev: React.DragEvent<HTMLDivElement>) => {
      ev.preventDefault();
      ev.stopPropagation();
      setState((old: DragAndDropViewState) => ({ ...old, isOver: true }));
      if (props.onDragEnter) {
        props.onDragEnter();
      }
    },
    [props]
  );
  const onDragLeave = useCallback(
    (ev: React.DragEvent<HTMLDivElement>) => {
      ev.preventDefault();
      ev.stopPropagation();
      const previous = state.isOver;
      setState((old: DragAndDropViewState) => ({ ...old, isOver: false }));
      if (previous && props.onDragOver) {
        props.onDragOver(false);
      }
    },
    [state.isOver, setState, props]
  );
  const onDragOver = useCallback(
    (ev: React.DragEvent<HTMLDivElement>) => {
      ev.preventDefault();
      ev.stopPropagation();
      const previous = state.isOver;
      setState((old: DragAndDropViewState) => ({ ...old, isOver: true }));
      if (!previous && props.onDragOver) {
        props.onDragOver(true);
      }
    },
    [state.isOver, setState, props]
  );
  const onDrop = useCallback(
    (ev: React.DragEvent<HTMLDivElement>) => {
      ev.preventDefault();
      ev.stopPropagation();
      setState((old: DragAndDropViewState) => ({ ...old, isOver: false }));
      if (props.onDrop) {
        const files: File[] = [];
        const filelist = ev.dataTransfer.files;
        for (let i = 0; i < filelist.length; i++) {
          const f = filelist.item(i);
          if (f) files.push(f);
        }
        if (files.length > 0) props.onDrop(files);
      }
    },
    [props]
  );
  return (
    <div
      className={props.className}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <div className={styles.childrenWrapper}>{props.children}</div>
    </div>
  );
};

export default DragAndDrop;
